var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonStoryQuote.jinja');
require('./CommonStoryQuote.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonStory/CommonStoryQuote.js
// module id = 174
// module chunks = 0